import React, { forwardRef } from 'react';
import {
  Medication,
  MedicationInterruptionStatus
} from '@/modules/surgicalEvent';
import { Alert, AlertTitle } from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';

export type MedsAutomationSnackProps = {
  medication: Medication;
};
export const MedsAutomationSnack = forwardRef<
  HTMLDivElement,
  MedsAutomationSnackProps & { style: any }
>(({ medication: med, style }, ref) => {
  const isUnknown =
    med.interruptionStatus === MedicationInterruptionStatus.UNKNOWN ||
    med.interruptionStatus === MedicationInterruptionStatus.TO_REVIEW;
  const isBridged =
    med.interruptionStatus === MedicationInterruptionStatus.STOP_AND_BRIDGE &&
    !!med.bridgedBy?.length;

  return (
    <Alert
      ref={ref}
      variant="filled"
      severity={isUnknown ? 'warning' : 'info'}
      style={style}
    >
      {isUnknown && (
        <>
          <AlertTitle>
            <TranslatedText
              id="doctor-dashboard.medsAutomation.updateSnackbar.unknown.title"
              values={{
                medName: med.name
              }}
            />
          </AlertTitle>
          <TranslatedText id="doctor-dashboard.medsAutomation.updateSnackbar.unknown.message" />
        </>
      )}

      {!isUnknown && isBridged && (
        <>
          <AlertTitle>
            {med.name}: {med.lastModifiedBy}{' '}
            <TranslatedText
              id={`doctor-dashboard.meds.interruptionStatus.${
                med.stopDaysBefore === 0
                  ? MedicationInterruptionStatus.STOP_ON_THE_DAY_OF_SURGERY
                  : MedicationInterruptionStatus.STOP_X_DAYS_BEFORE
              }`}
              values={{
                days: `${med.stopDaysBefore}`
              }}
            />
          </AlertTitle>
          <TranslatedText
            id="doctor-dashboard.medsAutomation.updateSnackbar.bridgeByBody"
            values={{
              medNames: med.bridgedBy!.map(({ name }) => name).join(', ')
            }}
          />
        </>
      )}

      {!isUnknown && !isBridged && (
        <>
          {med.name}:{' '}
          <TranslatedText
            id={`doctor-dashboard.meds.interruptionStatus.${med.interruptionStatus}`}
            values={{
              days: `${med.stopDaysBefore}`
            }}
          />
        </>
      )}
    </Alert>
  );
});

MedsAutomationSnack.displayName = 'MedsAutomationSnack';
